window.WCTableData = window.WCTableData || [];
window.WCTableData.push(
{
  "id": "tomato-basil-spaghetti",
  "priority": 11,
  "name": "15 MINUTE TOMATO BASIL SPAGHETTI",
  "occasions": [
    "spontaneous",
    "dinner",
    "date",
    "friends",
    "morning_after"
  ],
  "totalTime": 15,
  "difficulty": 1,
  "vibes": [
    "comfort",
    "mediterranean",
    "fresh"
  ],
  "drinkCats": [
    "wine",
    "beer",
    "alcoholfree",
    "open"
  ],
  "diet": "vegan",
  "lactoseLow": true,
  "budgetLow": 5,
  "budgetHigh": 8,
  "reason": "Ein Topf, eine Pfanne und Zutaten, die fast jeder bekommt – der zuverlässige Plan für Hunger ohne großes Hosting-Setup.",
  "food": "Zitroniger Rucola",
  "main": "Spaghetti mit Tomate, Knoblauch & Basilikum",
  "drink": "House Red",
  "naDrink": "Lemon Basil Tonic 0.0",
  "tableDetail": "Pasta in eine große Schüssel, Salat daneben, fertig.",
  "prep": "15 Minuten",
  "hostTip": "Knoblauch nur sanft gold werden lassen. Dunkler Knoblauch macht die schnelle Sauce bitter.",
  "ingredients": [
    {
      "group": "produce",
      "name": "Cherrytomaten",
      "qty": 500,
      "unit": "g"
    },
    {
      "group": "produce",
      "name": "Knoblauch",
      "qty": 2,
      "unit": "Zehen",
      "whole": true
    },
    {
      "group": "produce",
      "name": "Basilikum",
      "qty": 25,
      "unit": "g"
    },
    {
      "group": "produce",
      "name": "Rucola",
      "qty": 100,
      "unit": "g"
    },
    {
      "group": "produce",
      "name": "Bio-Zitrone",
      "qty": 1,
      "unit": "Stk.",
      "whole": true
    },
    {
      "group": "pantry",
      "name": "Spaghetti",
      "qty": 360,
      "unit": "g"
    },
    {
      "group": "pantry",
      "name": "Olivenöl",
      "qty": 45,
      "unit": "ml"
    },
    {
      "group": "pantry",
      "name": "Meersalz",
      "qty": 6,
      "unit": "g"
    },
    {
      "group": "pantry",
      "name": "Chiliflocken",
      "qty": 2,
      "unit": "g"
    }
  ],
  "drinkIngredients": [
    {
      "group": "drinks",
      "name": "Leichter Rotwein",
      "qty": 600,
      "unit": "ml"
    }
  ],
  "naDrinkIngredients": [
    {
      "group": "drinks",
      "name": "Tonic Water",
      "qty": 600,
      "unit": "ml"
    },
    {
      "group": "produce",
      "name": "Bio-Zitrone",
      "qty": 1,
      "unit": "Stk.",
      "whole": true
    },
    {
      "group": "produce",
      "name": "Basilikum",
      "qty": 8,
      "unit": "g"
    }
  ],
  "equipment": ["großer Topf", "große Pfanne", "Zange", "Salatschüssel"],
  "makeAhead": "Tomaten halbieren, Knoblauch schneiden und Rucola waschen. Die Sauce erst beginnen, wenn das Pastawasser kocht.",
  "serving": "Pasta in eine große warme Schüssel geben; Rucola separat servieren, damit er frisch bleibt.",
  "steps": [
    "Einen großen Topf Wasser aufkochen und kräftig salzen. Spaghetti nach Packungsangabe al dente kochen; 200 ml Kochwasser sichern.",
    "Währenddessen Knoblauch in dünne Scheiben schneiden. 30 ml Olivenöl in einer großen Pfanne auf mittlerer Stufe erhitzen.",
    "Knoblauch und Chiliflocken 60–90 Sekunden sanft braten, ohne den Knoblauch dunkel werden zu lassen.",
    "Tomaten zugeben, salzen und 6–8 Minuten braten, bis sie weich werden und teilweise aufplatzen. Mit 100 ml Kochwasser lösen.",
    "Spaghetti direkt in die Pfanne geben und 1 Minute schwenken. Basilikum grob zerreißen und unterheben.",
    "Rucola mit restlichem Olivenöl, 1 EL Zitronensaft und Salz mischen. Pasta abschmecken und sofort mit dem Salat servieren."
  ],
  "drinkSteps": [
    "Leichten Rotwein etwa 30 Minuten vor dem Essen in den Kühlschrank stellen.",
    "Bei ungefähr 14–16 °C einschenken; pro Person sind etwa 150 ml vorgesehen."
  ],
  "naDrinkSteps": [
    "Vier Gläser mit Eis füllen. Je zwei dünne Zitronenscheiben und zwei Basilikumblätter leicht darin andrücken.",
    "Je 150 ml Tonic aufgießen und vorsichtig rühren."
  ]
},
{
  "id": "sunday-brunch-focaccia-eggs",
  "priority": 12,
  "name": "SUNDAY FOCACCIA BRUNCH",
  "occasions": [
    "brunch",
    "morning_after",
    "friends"
  ],
  "totalTime": 30,
  "difficulty": 2,
  "vibes": [
    "brunch",
    "sharing",
    "comfort",
    "fresh"
  ],
  "drinkCats": [
    "cocktail",
    "alcoholfree",
    "coffee",
    "open"
  ],
  "diet": "vegetarian",
  "lactoseLow": true,
  "budgetLow": 9,
  "budgetHigh": 13,
  "reason": "Brunch, der nach Wochenende aussieht, aber ohne Pancake-Produktionsstraße auskommt: Eier, Focaccia, Tomaten und eine große Platte.",
  "food": "Tomaten-Gurken-Salat mit Kräutern",
  "main": "Soft Eggs, warme Focaccia & Chili Oil",
  "drink": "Mimosa",
  "naDrink": "Orange Sparkling 0.0",
  "tableDetail": "Eier halbieren, Brot reißen und alles als Brunch-Platte servieren.",
  "prep": "30 Minuten",
  "hostTip": "Eier sieben Minuten kochen und danach direkt kalt abschrecken – dann bleibt die Mitte cremig.",
  "ingredients": [
    {
      "group": "produce",
      "name": "Tomaten",
      "qty": 400,
      "unit": "g"
    },
    {
      "group": "produce",
      "name": "Gurke",
      "qty": 1,
      "unit": "Stk.",
      "whole": true
    },
    {
      "group": "produce",
      "name": "Petersilie",
      "qty": 20,
      "unit": "g"
    },
    {
      "group": "cooling",
      "name": "Eier",
      "qty": 8,
      "unit": "Stk.",
      "whole": true
    },
    {
      "group": "pantry",
      "name": "Focaccia",
      "qty": 400,
      "unit": "g"
    },
    {
      "group": "pantry",
      "name": "Chiliöl",
      "qty": 30,
      "unit": "ml"
    },
    {
      "group": "pantry",
      "name": "Olivenöl",
      "qty": 30,
      "unit": "ml"
    },
    {
      "group": "pantry",
      "name": "Meersalz",
      "qty": 5,
      "unit": "g"
    },
    {
      "group": "pantry",
      "name": "Schwarzer Pfeffer",
      "qty": 1,
      "unit": "g"
    }
  ],
  "drinkIngredients": [
    {
      "group": "drinks",
      "name": "Orangensaft",
      "qty": 300,
      "unit": "ml"
    },
    {
      "group": "drinks",
      "name": "Trockener Sekt",
      "qty": 300,
      "unit": "ml"
    }
  ],
  "naDrinkIngredients": [
    {
      "group": "drinks",
      "name": "Orangensaft",
      "qty": 300,
      "unit": "ml"
    },
    {
      "group": "drinks",
      "name": "Sparkling Tea 0.0",
      "qty": 300,
      "unit": "ml"
    }
  ],
  "equipment": ["kleiner Topf", "Backofen", "große Platte", "Schüssel"],
  "makeAhead": "Salatgemüse waschen und Petersilie hacken. Eier und Focaccia sollten frisch und lauwarm auf die Platte.",
  "serving": "Eier halbiert auf die Platte setzen, Chiliöl erst unmittelbar vor dem Servieren darübergeben.",
  "steps": [
    "Wasser in einem Topf zum Kochen bringen. Eier vorsichtig hineingeben und exakt 7 Minuten kochen.",
    "Eier sofort in sehr kaltem Wasser mindestens 3 Minuten abschrecken, anschließend vorsichtig pellen.",
    "Tomaten und Gurke mundgerecht schneiden. Mit gehackter Petersilie, Olivenöl, Salz und Pfeffer vermischen.",
    "Focaccia bei 190 °C 5–7 Minuten erwärmen und anschließend in große Stücke reißen.",
    "Eier halbieren und mit der Schnittfläche nach oben auf einer großen Platte anrichten. Leicht salzen und pfeffern.",
    "Salat und Focaccia ergänzen, Chiliöl über die Eier träufeln und alles sofort gemeinsam servieren."
  ],
  "drinkSteps": [
    "Orangensaft und Sekt vollständig vorkühlen.",
    "Je 75 ml Orangensaft in vier Gläser geben und langsam mit je 75 ml Sekt auffüllen; nicht rühren."
  ],
  "naDrinkSteps": [
    "Orangensaft und Sparkling Tea vollständig vorkühlen.",
    "Je 75 ml Orangensaft in vier Gläser geben und mit je 75 ml Sparkling Tea auffüllen."
  ]
},
{
  "id": "berry-ricotta-brunch",
  "priority": 13,
  "name": "BERRY RICOTTA BRUNCH BOARD",
  "occasions": [
    "brunch",
    "date",
    "morning_after",
    "friends"
  ],
  "totalTime": 15,
  "difficulty": 1,
  "vibes": [
    "brunch",
    "fresh",
    "sharing"
  ],
  "drinkCats": [
    "coffee",
    "alcoholfree",
    "open"
  ],
  "diet": "vegetarian",
  "lactoseLow": false,
  "budgetLow": 7,
  "budgetHigh": 10,
  "reason": "Süß, frisch und in 15 Minuten aufgebaut – ideal, wenn Brunch gut aussehen soll, ohne dass jemand eine Stunde am Herd steht.",
  "food": "Beeren, Zitrone & Honig",
  "main": "Ricotta Toast Board mit geröstetem Sauerteig",
  "drink": "Iced Coffee",
  "naDrink": "Iced Coffee",
  "tableDetail": "Ricotta auf einer Platte ausstreichen und Toast separat stapeln.",
  "prep": "15 Minuten",
  "hostTip": "Ricotta mit etwas Zitronenabrieb und einer Prise Salz aufschlagen – dadurch schmeckt er deutlich weniger schwer.",
  "ingredients": [
    {
      "group": "produce",
      "name": "Gemischte Beeren",
      "qty": 400,
      "unit": "g"
    },
    {
      "group": "produce",
      "name": "Bio-Zitrone",
      "qty": 1,
      "unit": "Stk.",
      "whole": true
    },
    {
      "group": "cooling",
      "name": "Ricotta",
      "qty": 400,
      "unit": "g"
    },
    {
      "group": "pantry",
      "name": "Sauerteigbrot",
      "qty": 8,
      "unit": "Scheiben",
      "whole": true
    },
    {
      "group": "pantry",
      "name": "Honig",
      "qty": 50,
      "unit": "g"
    },
    {
      "group": "pantry",
      "name": "Mandeln",
      "qty": 60,
      "unit": "g"
    },
    {
      "group": "pantry",
      "name": "Meersalz",
      "qty": 2,
      "unit": "g"
    }
  ],
  "drinkIngredients": [
    {
      "group": "drinks",
      "name": "Cold Brew",
      "qty": 800,
      "unit": "ml"
    },
    {
      "group": "cooling",
      "name": "Milch",
      "qty": 300,
      "unit": "ml"
    },
    {
      "group": "optional",
      "name": "Eis",
      "qty": 400,
      "unit": "g"
    }
  ],
  "naDrinkIngredients": [
    {
      "group": "drinks",
      "name": "Cold Brew",
      "qty": 800,
      "unit": "ml"
    },
    {
      "group": "cooling",
      "name": "Milch",
      "qty": 300,
      "unit": "ml"
    },
    {
      "group": "optional",
      "name": "Eis",
      "qty": 400,
      "unit": "g"
    }
  ],
  "equipment": ["Backblech oder Toaster", "Rührschüssel", "Schneebesen", "große Platte"],
  "makeAhead": "Mandeln rösten und Beeren waschen. Ricotta maximal 1 Stunde vorher aufschlagen und kalt stellen.",
  "serving": "Ricotta breit ausstreichen und Brot separat stapeln, damit jeder seinen Toast frisch belegt.",
  "steps": [
    "Mandeln in einer trockenen Pfanne 3–4 Minuten goldbraun rösten, abkühlen lassen und grob hacken.",
    "Beeren waschen und vollständig trocknen. Große Erdbeeren oder Beeren halbieren.",
    "Ricotta mit 1 TL Zitronenabrieb, 1 EL Zitronensaft und einer Prise Salz 1 Minute cremig aufschlagen.",
    "Sauerteigbrot im Toaster oder bei 220 °C im Ofen 5–7 Minuten kräftig rösten.",
    "Ricotta auf einer großen Platte ausstreichen. Beeren locker darauf verteilen und Honig darüberziehen.",
    "Mit Mandeln und etwas zusätzlichem Zitronenabrieb abschließen; warmes Brot separat dazustellen."
  ],
  "drinkSteps": [
    "Vier Gläser vollständig mit Eis füllen und je 200 ml Cold Brew hineingeben.",
    "Je nach Geschmack 50–75 ml kalte Milch dazugeben und einmal umrühren."
  ],
  "naDrinkSteps": [
    "Vier Gläser vollständig mit Eis füllen und je 200 ml Cold Brew hineingeben.",
    "Je nach Geschmack 50–75 ml kalte Milch oder Pflanzendrink dazugeben und einmal umrühren."
  ]
},
{
  "id": "morning-after-crispy-potatoes",
  "priority": 14,
  "name": "THE MORNING AFTER PAN",
  "occasions": [
    "morning_after",
    "brunch",
    "friends"
  ],
  "totalTime": 45,
  "difficulty": 2,
  "vibes": [
    "brunch",
    "comfort",
    "sharing"
  ],
  "drinkCats": [
    "beer",
    "alcoholfree",
    "coffee",
    "open"
  ],
  "diet": "vegetarian",
  "lactoseLow": true,
  "budgetLow": 7,
  "budgetHigh": 10,
  "reason": "Knusprige Kartoffeln, Eier und etwas Frisches obendrauf – genau das richtige Niveau zwischen Frühstück und Reparaturmaßnahme.",
  "food": "Tomaten-Gurken-Relish",
  "main": "Crispy Potatoes & Jammy Eggs",
  "drink": "Cold Brew",
  "naDrink": "Ginger Lemon Soda",
  "tableDetail": "Die Pfanne kommt direkt auf den Tisch.",
  "prep": "45 Minuten",
  "hostTip": "Kartoffeln klein würfeln und nicht überladen braten – dann werden sie wirklich knusprig.",
  "ingredients": [
    {
      "group": "produce",
      "name": "Kartoffeln",
      "qty": 1000,
      "unit": "g"
    },
    {
      "group": "produce",
      "name": "Tomaten",
      "qty": 300,
      "unit": "g"
    },
    {
      "group": "produce",
      "name": "Gurke",
      "qty": 1,
      "unit": "Stk.",
      "whole": true
    },
    {
      "group": "produce",
      "name": "Frühlingszwiebeln",
      "qty": 4,
      "unit": "Stk.",
      "whole": true
    },
    {
      "group": "cooling",
      "name": "Eier",
      "qty": 8,
      "unit": "Stk.",
      "whole": true
    },
    {
      "group": "pantry",
      "name": "Olivenöl",
      "qty": 50,
      "unit": "ml"
    },
    {
      "group": "pantry",
      "name": "Paprikapulver",
      "qty": 4,
      "unit": "g"
    },
    {
      "group": "pantry",
      "name": "Meersalz",
      "qty": 6,
      "unit": "g"
    },
    {
      "group": "pantry",
      "name": "Schwarzer Pfeffer",
      "qty": 1,
      "unit": "g"
    }
  ],
  "drinkIngredients": [
    {
      "group": "drinks",
      "name": "Cold Brew",
      "qty": 800,
      "unit": "ml"
    }
  ],
  "naDrinkIngredients": [
    {
      "group": "drinks",
      "name": "Ginger Ale 0.0",
      "qty": 700,
      "unit": "ml"
    },
    {
      "group": "produce",
      "name": "Bio-Zitrone",
      "qty": 1,
      "unit": "Stk.",
      "whole": true
    }
  ],
  "equipment": ["sehr große Pfanne", "Topf", "Schüssel", "Pfannenwender"],
  "makeAhead": "Kartoffeln können am Vorabend 8 Minuten vorgekocht und kalt gestellt werden. Dadurch werden sie morgens schneller knusprig.",
  "serving": "Relish erst ganz am Ende auf einen Teil der Kartoffeln geben, damit genug knusprige Stellen bleiben.",
  "steps": [
    "Kartoffeln in etwa 1,5 cm große Würfel schneiden. Optional 8 Minuten in Salzwasser vorkochen, abgießen und gut ausdampfen lassen.",
    "Eine große Pfanne auf mittelhoher Stufe erhitzen. Öl, Kartoffeln, Paprikapulver und Salz zugeben.",
    "Kartoffeln 20–25 Minuten knusprig braten; nur alle 4–5 Minuten wenden. Bei vorgekochten Kartoffeln reichen meist 12–15 Minuten.",
    "Parallel Eier in kochendem Wasser 7 Minuten garen, sofort kalt abschrecken, pellen und halbieren.",
    "Tomaten, Gurke und Frühlingszwiebeln fein würfeln. Mit einer Prise Salz und schwarzem Pfeffer mischen.",
    "Kartoffeln final abschmecken, Relish locker darübergeben und Eier mit der Schnittfläche nach oben daraufsetzen."
  ],
  "drinkSteps": [
    "Cold Brew vollständig vorkühlen.",
    "Je 200 ml über frisches Eis geben und zum heißen Pfannengericht servieren."
  ],
  "naDrinkSteps": [
    "Vier Gläser mit Eis und je zwei dünnen Zitronenscheiben füllen.",
    "Je etwa 175 ml Ginger Ale aufgießen und einmal vorsichtig umrühren."
  ]
}
);
